export default "__VITE_ASSET__iPN7lPP6__"